/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/*!***************************!*\
  !*** ./es-pack-banner.ts ***!
  \***************************/


(function () {
  //NEED REMOVE
  document.addEventListener('DOMContentLoaded', () => {
    init();
    reInitCustomizer();
  });
  function init() {
    if (!window.ES_PACK_SELECTOR.selectors['es_pack_selector_main']) return;
    var selector = window.ES_PACK_SELECTOR.selectors['es_pack_selector_main'];
    if (!selector) return;
    var rootEl = document.querySelector('[data-es-pack-banner]');
    if (!rootEl) return;
    var oneTimeImageEls = rootEl.querySelectorAll('[data-es-pack-banner-one-time-image]');
    var membershipImageEls = rootEl.querySelectorAll('[data-es-pack-banner-membership-image]');
    if (!(oneTimeImageEls !== null && oneTimeImageEls !== void 0 && oneTimeImageEls.length) || !(membershipImageEls !== null && membershipImageEls !== void 0 && membershipImageEls.length)) return;
    selector.addEventListener('onChange', key => {
      if (key === 'onetime') {
        oneTimeImageEls.forEach(i => i.classList.remove('es-hidden'));
        membershipImageEls.forEach(i => i.classList.add('es-hidden'));
      } else {
        oneTimeImageEls.forEach(i => i.classList.add('es-hidden'));
        membershipImageEls.forEach(i => i.classList.remove('es-hidden'));
      }
    });
  }
  function reInitCustomizer() {
    var _Shopify;
    // @ts-ignore
    if (Shopify && (_Shopify = Shopify) !== null && _Shopify !== void 0 && _Shopify.designMode) {
      document.addEventListener('shopify:inspector:activate', init);
      document.addEventListener('shopify:inspector:deactivate', init);
      document.addEventListener('shopify:section:load', init);
      document.addEventListener('shopify:section:unload', init);
      document.addEventListener('shopify:section:select', init);
      document.addEventListener('shopify:section:deselect', init);
      document.addEventListener('shopify:section:reorder', init);
      document.addEventListener('shopify:block:select', init);
      document.addEventListener('shopify:block:deselect', init);
    }
  }
})();
/******/ })()
;